import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    try {
      // Replace with your backend endpoint
      const res = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        setStatus('Thank you for subscribing!');
        setEmail('');
      } else {
        setStatus('Subscription failed. Please try again.');
      }
    } catch {
      setStatus('Subscription failed. Please try again.');
    }
  };

  return (
    <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
        <motion.h1
          className="text-4xl font-bold text-brand-blue mb-6 text-center"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          Newsletter Signup
        </motion.h1>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="Your email address"
            className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
          />
          <button type="submit" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold">Subscribe</button>
        </form>
        {status && <p className="mt-4 text-center text-blue-600 font-medium">{status}</p>}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
          <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
        </div>
      </div>
    </section>
  );
};

export default Newsletter; 